import { Label, Select } from '@/components/Forms/styles';
import { SelectBoxArrowDown } from '@icons/SelectBoxArrowDown';

type Option = { value: string; label: string };

type Props = {
  name: string;
  title?: string;
  label: string;
  options: Option[];
  onChange?: (value: string) => void;
};

const Web2CaseSelect = ({ name, title, label, options, onChange }: Props) => {
  return (
    <div className="relative">
      <Label htmlFor={name}>{label}</Label>

      <Select
        id={name}
        name={name}
        title={title}
        onChange={(e) => onChange && onChange(e.target.value)}
      >
        {options.map((option) => (
          <option value={option.value} key={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
      <div className="absolute right-5 bottom-3">
        <SelectBoxArrowDown />
      </div>
    </div>
  );
};

export default Web2CaseSelect;
